import axios from 'axios'
import session from 'vue-cookies'
const BASE_URL =  'https://api.bertiebets.com/prediction-config/'
//const BASE_URL =   'https://b4pssbgsg8.execute-api.us-east-1.amazonaws.com/prod/prediction-config/'
var key = session.get('bertiebets.admin.key')
export function listPredictionConfigs() {
  return new Promise ((resolve, reject) => {
    console.log("LIsting")
    axios
    .get(BASE_URL, {headers:{'x-api-key' : key}})
    .then(response => {
      if (response.status === 200) {
        resolve(response.data)
      }else {
        reject(response.status)
      }
    })
    .catch (err => {
      console.log(err)
      reject(err)
    })
  })
}

export function getPredictionConfig(name) {
  return new Promise ((resolve, reject) => {
    axios
    .get(BASE_URL + name, {headers:{'x-api-key' : key}})
    .then(response => {
      if (response.status === 200) {
        resolve(response.data)
      }else {
        reject(response.status)
      }
    })
    .catch (err => {
      reject(err)
    })
  })
}

export function updatePredictionConfig(name, data, password) {
  return new Promise ((resolve, reject) => {
    axios
    .post(BASE_URL + name, data, {headers:{'x-api-key' : key, password: password}})
    .then(response => {
      resolve(response)
    })
    .catch (err => {
      reject(err)
    })
  })
}

export function archivePredictionConfig(configName, password) {
  return new Promise ((resolve, reject) => {
    axios
    .delete(BASE_URL + configName, {headers:{'x-api-key' : key, password: password}})
    .then(response => {
      resolve(response)
    })
    .catch (err => {
      reject(err)
    })
  })
}
